import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { DropdownItem, DropdownItemGroup } from "@atlaskit/dropdown-menu";

import { LoggedInUserDropdownProps } from "@/components/global-nav/user-profile-new/src/components/loggedin-user-view";
import { messages } from "@/components/global-nav/user-profile-new/src/messages";

const mobileLoggedInUserContainer = css({
    ".global-nav-userinfo": {
        "paddingBlockStart": "16px",
        "paddingBlockEnd": "16px",
        ".global-nav-userinfo-displayName": {
            color: "#505258",
            marginBlockStart: "8px",
            marginBlockEnd: "8px"
        },
        ".global-nav-userinfo-email": {
            color: "#101214",
            fontWeight: "700",
            marginBlockStart: "8px",
            marginBlockEnd: "8px"
        }
    }
});

const MobileLoggedInUseDropdown = ({
    userInfo,
    onLogOutClick,
    onManageLicensesClick,
    onManageProfileClick,
    onSwitchAccountClick
}: LoggedInUserDropdownProps) => {
    return (
        <div
            css={mobileLoggedInUserContainer}
            data-testid="global-nav-mobile-user-profile-container-user-loggedin"
        >
            <DropdownItemGroup>
                <DropdownItem isDisabled={true}>
                    <div className="global-nav-userinfo">
                        <div className="global-nav-userinfo-displayName">
                            {userInfo.displayName}
                        </div>
                        <div className="global-nav-userinfo-email">
                            {userInfo.email}
                        </div>
                    </div>
                </DropdownItem>
                <DropdownItem onClick={onSwitchAccountClick}>
                    <FormattedMessage {...messages.switchAccount} />
                </DropdownItem>
                <DropdownItem onClick={onManageProfileClick}>
                    <FormattedMessage {...messages.profile} />
                </DropdownItem>
                <DropdownItem onClick={onManageLicensesClick}>
                    <FormattedMessage {...messages.licenses} />
                </DropdownItem>
                <DropdownItem onClick={onLogOutClick}>
                    <FormattedMessage {...messages.logOut} />
                </DropdownItem>
            </DropdownItemGroup>
        </div>
    );
};

export default MobileLoggedInUseDropdown;
